import gql from "graphql-tag";

export const MY_HR_CLEAN_CACHE = gql`
  mutation cleanCache {
    cleanCache
  }
`;
